module.exports = __webpack_public_path__ + "img/arrow-circle-down.6b8a57ce.svg";